import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { space, layout, flexbox } from 'styled-system';
import { Plus } from '../plus/Plus';
export var List = styled.div(_templateObject(), space, layout, flexbox);
/**
 * @typedef GroupProp
 * @property {React.ReactNode} children
 * @property {number} maxCounts
 * @property {any} itemStyle
 */

/**
 * @param {GroupProp}
 */

export var Group = function Group(_ref) {
  var children = _ref.children,
      maxCounts = _ref.maxCounts,
      itemStyle = _ref.itemStyle,
      rest = _objectWithoutProperties(_ref, ["children", "maxCounts", "itemStyle"]);

  var arr = React.Children.toArray(children);
  var hiddenCounts = arr.length - maxCounts;
  return (
    /*#__PURE__*/
    React.createElement(List, rest, arr.slice(0, maxCounts).map(function (child) {
      return (
        /*#__PURE__*/
        React.cloneElement(child, itemStyle)
      );
    }), hiddenCounts > 0 &&
    /*#__PURE__*/
    React.createElement(Plus, {
      number: hiddenCounts
    }))
  );
};
Group.defaultProps = {
  maxCounts: Infinity,
  itemStyle: {
    mr: '4px'
  },
  width: '100%'
};